import axios from "axios";
import { BASE_URLS } from "../../api/axios";
import Cookies from "js-cookie";

const getToken = () =>
  Cookies.get("accessToken") || Cookies.get("token") || null;

export const axiosCabinet = axios.create({
  baseURL: BASE_URLS.RDV,
  withCredentials: true,
});

axiosCabinet.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
